export default function SvgChevronDown(props) {
    return (
        <svg {...props} viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.257885 0C0.257885 0 0.257885 0 0.257885 0C0.0422895 0 -0.0655081 0.219178 0.0422895 0.344423L3.24028 3.88258C3.38401 4.03914 3.63554 4.03914 3.74334 3.88258L6.94133 0.344423C7.08506 0.187867 6.94133 0 6.76167 0H2.44977H0.257885C0.257885 0 0.257885 0 0.257885 0Z" fill="currentColor"/>
        </svg>
    )
}